export const STATUS_NOT_APPROVED = 0;
export const STATUS_APPROVED = 1;

export const MASTER_STATUSES = {
    [STATUS_NOT_APPROVED]: {
        name: 'Not Approved'
    },
    [STATUS_APPROVED]: {
        name: 'Approved'
    }
}
